import { render, staticRenderFns } from "./index.vue?vue&type=template&id=affb69ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=affb69ca&prod&lang=stylus"
import style1 from "./index.vue?vue&type=style&index=1&id=affb69ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb69ca",
  null
  
)

export default component.exports